import { createGlobalState } from "@vueuse/core";
import { ref } from "vue";

const useContractChangeCountState = createGlobalState(() => ref(0));

// The contract and amendment lists are kept alive: after a change made elsewhere (a header action, an upload,
// a correction), they must reload when the user comes back instead of showing the old status.
// Each caller tracks the changes it has already seen, so the contract list and the amendment list reload once each.
export const useContractListRefresh = () => {
  const contractChangeCount = useContractChangeCountState();
  let seenChangeCount = contractChangeCount.value;

  const markContractListNeedsRefresh = () => {
    contractChangeCount.value++;
  };

  const consumeContractListNeedsRefresh = () => {
    if (seenChangeCount === contractChangeCount.value) {
      return false;
    }

    seenChangeCount = contractChangeCount.value;
    return true;
  };

  return {
    markContractListNeedsRefresh,
    consumeContractListNeedsRefresh,
  };
};
